import React from 'react';
import { Message } from '../styles';
import MessagesInputBox from '../../../inputBox/messageInputBox';
import { buildMessageUploadFolder, isEmpty } from '../../../../helpers/common';
import { TiptapEditorRef } from '../../../../interfaces/tiptapInterface';
import { ReplyMessageDataInterface } from '../../../../interfaces/MessageInterface';
import { ChatGroupInterface } from '../../../../interfaces/chatMessageInterface';
import { ProjectModel } from '../../../../mobx/models/project';
import { CHAT_GROUP_TYPE } from '../../../../global/constants';
import { getIsEveryoneMentionEnable } from '../../../../helpers/mentionHelper';

interface Props {
  inlineRef: React.RefObject<TiptapEditorRef> | null;
  onClickSelectFile: () => void;
  isNavbarMessage: boolean;
  currentProject: ProjectModel | ChatGroupInterface | null;
  sendComment: () => void;
  replyMessage: ReplyMessageDataInterface;
  setReplyMessage: () => void;
  isProjectDetail: boolean;
  handleOpenSnapModal: () => void;
  handleOpenGifModal: () => void;
  isAutoFocus: boolean;
  disable: boolean;
  isKeyboardVisible: boolean;
  iconSectionRef?: React.RefObject<HTMLDivElement>;
}

const MessageInputSection: React.FC<Props> = ({
  inlineRef,
  onClickSelectFile,
  isNavbarMessage,
  currentProject,
  sendComment,
  replyMessage,
  setReplyMessage,
  isProjectDetail,
  handleOpenSnapModal,
  handleOpenGifModal,
  isAutoFocus,
  disable,
  isKeyboardVisible,
  iconSectionRef
}) => {
  const isEveryoneMentionEnable = getIsEveryoneMentionEnable(currentProject, isNavbarMessage);

  const users = (currentProject?.users || []).filter((user) => !isEmpty(user?.id));

  const isSelectFileEnable = isNavbarMessage
    ? (currentProject as ChatGroupInterface)?.type !== CHAT_GROUP_TYPE.PERSONAL
    : true;

  const uploadFolder = buildMessageUploadFolder(currentProject?.id);

  return (
    <Message>
      <MessagesInputBox
        ref={inlineRef}
        onClickSelectFile={onClickSelectFile}
        isEveryoneMentionEnable={isEveryoneMentionEnable}
        users={users}
        sendComment={sendComment}
        replyMessage={replyMessage}
        setReplyMessage={setReplyMessage}
        isSelectFileEnable={isSelectFileEnable}
        isProjectDetail={isProjectDetail}
        handleOpenSnapModal={handleOpenSnapModal}
        handleOpenGifModal={handleOpenGifModal}
        isCalendarViewCard={true}
        isAutoFocus={isAutoFocus}
        disable={disable}
        isKeyboardVisible={isKeyboardVisible}
        iconSectionRef={iconSectionRef}
        uploadFolder={uploadFolder}
      />
    </Message>
  );
};

export default React.memo(MessageInputSection);
